export interface SubscriptionPacketTranslation {
    id;
    subscriptionPacketId;
    name;
    language;
}

export class SubscriptionPacketDto {
    id = null;
    siteId = 0;
    markForDeletion = false;
    packetTranslations: SubscriptionPacketTranslation[] = [];
    price;
    effectiveDays;
    discount;
    packetEnd;
    packetStart;
}